var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7e385466f6f9be4e86d753f2bec1264504192e17"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-20-next@plant-for-the-planet"]={id:"7e385466f6f9be4e86d753f2bec1264504192e17"};
      